import { render } from "./RequestStatusControls.vue?vue&type=template&id=dc272214"
import script from "./RequestStatusControls.vue?vue&type=script&lang=js"
export * from "./RequestStatusControls.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/RequestStatus/RequestStatusControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc272214"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc272214', __exports__)) {
    api.reload('dc272214', __exports__)
  }
  
  module.hot.accept("./RequestStatusControls.vue?vue&type=template&id=dc272214", () => {
    api.rerender('dc272214', render)
  })

}


export default __exports__